import React, { useState } from "react";
import { Link } from "react-scroll";
const Home = () => {
  const [modalImage, setModalImage] = useState(null);

  const openModal = (imageSrc) => {
    setModalImage(imageSrc);
  };

  const closeModal = () => {
    setModalImage(null);
  };
  return (
    <div>
      <div className="site-mobile-menu site-navbar-target">
        <div className="site-mobile-menu-header">
          <div className="site-mobile-menu-close">
            <span className="icofont-close js-menu-toggle" />
          </div>
        </div>
        <div className="site-mobile-menu-body" />
      </div>
      {/*  */}

      <nav className="site-nav dark mb-5 site-navbar-target">
        <div className="container">
          <div className="site-navigation">
            <a href="#home-section" className="logo m-0">
              Rohi<span className="text-primary">.</span>
            </a>
            <ul className="site-menu float-right site-nav-wrap">
              <li>
                <Link to="home-section" smooth={true} duration={500} className="nav-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="about-section" smooth={true} duration={500} className="nav-link">
                  About
                </Link>
              </li>
              <li>
                <Link to="skill-section" smooth={true} duration={500} className="nav-link">
                  Skills
                </Link>
              </li>
              <li>
                <Link to="mywork-section" smooth={true} duration={500} className="nav-link">
                  My Works
                </Link>
              </li>
              <li>
                <Link to="certificate-section" smooth={true} duration={500} className="nav-link">
                  Certificate
                </Link>
              </li>
              <li>
                <Link to="contact-section" smooth={true} duration={500} className="nav-link">
                  Contact
                </Link>
              </li>
            </ul>
            {/* <a
              href="#"
              className="burger ml-auto float-right site-menu-toggle js-menu-toggle d-inline-block d-lg-inline-block"
              data-toggle="collapse"
              data-target="#main-navbar"
            >
              <span />
            </a> */}
          </div>
        </div>
      </nav>
      <div className="untree_co-section pb-0" id="home-section">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-md-7">
              <h1 className="heading gsap-reveal-hero mb-3">
                <strong>
                  ROHAN&nbsp;
                  <span
                    className="text-primary-1"
                    style={{ color: "red" }}
                  ></span>
                  ITALIYA
                </strong>
              </h1>
              <h2 className="subheading gsap-reveal-hero mb-4">
                Hi there! I build Website along with apps.
              </h2>
              <a
                href="https://www.linkedin.com/in/rohan-italiya/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="images/linkedin.svg"
                  alt="Linkedin Logo"
                  className="img-fluid rounded-circle"
                />
              </a>
              <a
                href="https://github.com/rohi1810"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="images/github.svg"
                  alt="Github Logo"
                  className="img-fluid rounded-circle ml-3"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div id="portfolio-single-holder" />

      <div className="untree_co-section pb-0" id="about-section">
        <div className="container">
          {/* <div className="row justify-content-center mb-3">
            <div className="col-lg-7 mx-auto text-center author-wrap">
              <img
                // src="images/myimage.svg"
                // alt="Image"-
                className="img-fluid rounded-circle mb-3"
              />
              <h3 className="text-black h5 font-weight-bold mb-2 gsap-reveal-hero">
                App and Web Developer
              </h3>
            </div>
          </div> */}
          <div className="row">
            <div className="col">
              <section id="cd-timeline" className="cd-container ">
                <div className="cd-timeline-block ">
                  {/* <div className="cd-timeline-img cd-picture"></div> */}
                  <div className="cd-timeline-content ">
                    <h2 className="gsap-reveal-hero">Rutilant Technology</h2>
                    <div className="timeline-content-info ">
                      <span className="timeline-content-info-title gsap-reveal-hero">
                        <i className="fa fa-certificate" aria-hidden="true" />
                        Website & Application Developer
                      </span>
                      <span className="timeline-content-info-date gsap-reveal-hero">
                        <i className="fa fa-calendar" aria-hidden="true" />
                        Feb 2024 - Jun 2024
                      </span>
                    </div>
                    <ul className="skills-list">
                      <li className="skills-list-item">
                        Developed and optimized responsive web applications using React.js, JavaScript, HTML, and CSS, boosting user engagement by
                        30%.
                      </li>
                      <li className="skills-list-item">
                        Enhanced an educational Flutter application with AI-driven personalization features, increasing user engagement by 20%.
                      </li>
                      <li className="skills-list-item">
                        Created interactive UI components with custom styling, reducing user drop-off rates by 25%.

                      </li>
                      <li className="skills-list-item">
                        Improved website performance with efficient coding, lazy loading, and caching, achieving load times.
                      </li>
                      {/* <li className="skills-list-item">
                        Built and customized Shopify, WordPress, and CMS-based e-commerce sites, increasing sales conversions by 20%.
                      </li> */}
                      <li className="skills-list-item">
                        Ensured cross-browser and mobile compatibility, achieving 95% user satisfaction.
                      </li>
                      <li className="skills-list-item">
                        Worked with UI/UX designers and backend teams to create scalable, engaging web experiences, improving project efficiency by 15%.
                      </li>
                    </ul>

                    <ul className="content-skills">
                      <li className="gsap-reveal-hero">React Js</li>
                      <li className="gsap-reveal-hero">Javascript</li>
                      <li className="gsap-reveal-hero">HTML</li>
                      <li className="gsap-reveal-hero">Flutter</li>
                      <li className="gsap-reveal-hero">Dart</li>
                      <li className="gsap-reveal-hero">CSS</li>
                    </ul>
                  </div>
                </div>

                <div className="cd-timeline-block">
                  {/* <div className="cd-timeline-img cd-movie"></div> */}
                  <div className="cd-timeline-content">
                    <h2 className="gsap-reveal-hero">Codilite</h2>
                    <div
                      className="timeline-content-info"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <span className="timeline-content-info-title gsap-reveal-hero">
                        <i className="fa fa-certificate" aria-hidden="true" />
                        Application Developer
                      </span>
                      <span className="timeline-content-info-date gsap-reveal-hero">
                        <i className="fa fa-calendar" aria-hidden="true" />
                        May 2023 - Jan 2024
                      </span>
                    </div>
                    <ul className="skills-list">
                      <li className="skills-list-item">
                        Redesigned and developed an interactive learning game (ages 2–7) in Flutter, improving handwriting, language, spelling, and math skills, increasing educational effectiveness by 30%.
                      </li>
                      <li className="skills-list-item">
                        Integrated RESTful APIs to enhance data retrieval and user interactions, reducing page load times by 40%.
                      </li>
                      <li className="skills-list-item">
                        Designed and implemented animations and engaging UI elements, contributing to a 20% increase in user satisfaction ratings.
                      </li>
                    </ul>

                    <ul className="content-skills">
                      <li className="gsap-reveal-hero">MVC/MVVM</li>
                      <li className="gsap-reveal-hero">Webflow</li>
                      <li className="gsap-reveal-hero">RESTful APIs</li>
                      <li className="gsap-reveal-hero">Figma</li>
                      <li className="gsap-reveal-hero">Firebase</li>
                      <li className="gsap-reveal-hero">Git</li>
                      <li className="gsap-reveal-hero">Agile</li>
                    </ul>
                  </div>
                </div>

                <div className="cd-timeline-block">
                  {/* <div className="cd-timeline-img cd-picture"></div> */}
                  <div className="cd-timeline-content">
                    <h2 className="gsap-reveal-hero">Meritorious Infotech</h2>
                    <div
                      className="timeline-content-info "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <span className="timeline-content-info-title gsap-reveal-hero">
                        <i className="fa fa-certificate" aria-hidden="true" />
                        Internship Trainee
                      </span>
                      <span className="timeline-content-info-date gsap-reveal-hero">
                        <i className="fa fa-calendar" aria-hidden="true" />
                        Nov 2022 - Jan 2023
                      </span>
                    </div>
                    <ul className="skills-list">
                      <li className="skills-list-item">
                        Developed a pregnancy tracker and water drink reminder
                        application from scratch using SQL database technology.
                      </li>
                      <li className="skills-list-item">
                        Designed the database structure to store user’s
                        pregnancy information such as due date, week of
                        pregnancy, water intake history, and reminders.
                      </li>
                      <li className="skills-list-item">
                        Utilized SQL to manage the data, including inserting,
                        updating, and retrieving information to provide a
                        seamless and personalized user experience.
                      </li>
                    </ul>

                    <ul className="content-skills">
                      <li className="gsap-reveal-hero">C</li>
                      <li className="gsap-reveal-hero">C++</li>
                      <li className="gsap-reveal-hero">SQL</li>
                      <li className="gsap-reveal-hero">HTML</li>
                      <li className="gsap-reveal-hero">CSS</li>
                      <li className="gsap-reveal-hero">JavaScript</li>
                    </ul>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
      <div className="untree_co-section-1 pb-0" id="skill-section">
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-7 text-center mx-auto">
              <h2 className="section-heading gsap-reveal-hero mb-0">
                <strong>My Skillset</strong>
              </h2>
              <div className="wave ">
                <svg>
                  <path d="M10,10 L50,100 L90,50" stroke="#abc4ff" />
                </svg>
              </div>
            </div>
          </div>
          <div className="row">
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={0}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={98}> */}
                {/* <div className="number" /> */}
                <p className="caption">Flutter</p>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={85}> */}
                {/* <div className="number" /> */}
                <p className="caption">Bootstrap</p>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={88}> */}
                {/* <div className="number" /> */}
                <p className="caption">CSS</p>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={100}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={95}> */}
                {/* <div className="number" /> */}
                <p className="caption">Tailwind CSS</p>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={100}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={95}> */}
                {/* <div className="number" /> */}
                <p className="caption">Dart</p>
                {/* </div> */}
              </div>
            </div>



            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={85}> */}
                {/* <div className="number" /> */}
                <p className="caption">JavaScript</p>
                {/* </div> */}
              </div>
            </div>
            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={70}> */}
                {/* <div className="number" /> */}
                <p className="caption">CI/CD</p>
                {/* </div> */}
              </div>
            </div>

            <div
              className="col-6 col-sm-6 col-md-6 col-lg-3 text-center"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="progressbar" data-animate="false">
                {/* <div className="circle" data-percent={70}> */}
                {/* <div className="number" /> */}
                <p className="caption">React Js</p>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="untree_co-section-1 pb-0" id="mywork-section">
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-7 text-center mx-auto">
              <h2 className="section-heading  mb-0">
                <strong>My Works</strong>
              </h2>
              <div className="wave ">
                <svg>
                  <path d="M10,10 L50,100 L90,50" stroke="#abc4ff" />
                </svg>
              </div>
            </div>
          </div>
          <div class="row">
            <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>Inforens
                </h4>
                <a href="https://apps.apple.com/in/app/inforens/id6711349165" target="_blank">Link
                </a>

                <p>
                  platform designed for international students, guiding them from university shortlisting to career success with personalized dashboards, mentoring access, and intelligent application tools.
                </p>
              </div>
            </div>
            <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>Pasiv
                </h4>
                <a href="https://apps.apple.com/in/app/pasiv-smarter-wealth/id1496494065" target="_blank">Link</a>

                <p>
                  Smart investing assistant that enables users to micro-invest in US stocks and ETFs, manage portfolios via AI chat, automate roundups, and execute trades securely with real-time insights.                              </p>
              </div>
            </div>
            <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>DeliveryLo
                </h4>
                <a href="https://apps.apple.com/in/app/deliverylo/id6444193643" target="_blank">Link</a>

                <p>
                  On-demand delivery platform providing rapid grocery, food, and parcel services, including Pick & Drop functionality with real-time order tracking.
                </p>
              </div>
            </div>

          </div>
          <div class="row">
            <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>PayRemit
                </h4>
                <a href="https://apps.apple.com/in/app/payremit/id6449449744" target="_blank">Link
                </a>

                <p>
                  Secure financial services app enabling Overseas Filipino Workers to manage and monitor government contributions globally with real-time tracking and support.                </p>
              </div>
            </div>
            <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>Tubo.ph
                </h4>
                <a href="https://apps.apple.com/in/app/tubo-ph/id6477137169" target="_blank">Link</a>

                <p>
                  Offline-ready timekeeping and leave management system using geotagging and eKYC verification to track attendance for field, hybrid, and remote teams.                                    </p>
              </div>
            </div>
            {/* <div className=" col-md-6 col-lg-4 mb-4">
              <div class="card">
                <h4>DeliveryLo
                </h4>
                <a href="https://apps.apple.com/in/app/deliverylo/id6444193643" target="_blank">Link</a>

                <p>
                  On-demand delivery platform providing rapid grocery, food, and parcel services, including Pick & Drop functionality with real-time order tracking.
                </p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
      <div className="untree_co-section-2 pb-0" id="certificate-section">
        <div className="container">
          <div className="row mb-4">
            <div className="col-lg-7 text-center mx-auto">
              <h2 className="section-heading  mb-0">
                <strong>Certificate</strong>
              </h2>
              <div className="wave ">
                <svg>
                  <path d="M10,10 L50,100 L90,50" stroke="#abc4ff" />
                </svg>
              </div>
            </div>
          </div>
          <div className="row">
            {[1, 2, 6, 3, 4, 8, 5, 7, 10].map((item, index) => (
              <div
                key={index}
                className="col-6 col-sm-6 col-md-6 col-lg-4 mb-4"
              >
                <div className="overlay-effect effects clearfix">
                  <div className="img">
                    <img
                      className="grayscale img-fluid"
                      src={`images/certificate_${item}.jpg`}
                      alt="Portfolio Item"
                      onClick={() =>
                        openModal(`images/certificate_${item}.jpg`)
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="site-footer" id="contact-section">
        <div className="container">
          <div className="row">
            {/* <div className="col-lg-3">
              <div className="widget">
                <h3>Home</h3>
                <ul className="list-unstyled float-left links">
                  <li>
                    <a href="#">Untree.co</a>
                  </li>
                  <li>
                    <a href="#">About us</a>
                  </li>
                  <li>
                    <a href="#">Projects</a>
                  </li>
                  <li>
                    <a href="#">Services</a>
                  </li>
                  <li>
                    <a href="#">Terms</a>
                  </li>
                  <li>
                    <a href="#">Privacy</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="widget">
                <h3>Projects</h3>
                <ul className="list-unstyled float-left links">
                  <li>
                    <a href="#">HTML5</a>
                  </li>
                  <li>
                    <a href="#">CSS3</a>
                  </li>
                  <li>
                    <a href="#">Untree.co</a>
                  </li>
                  <li>
                    <a href="#">Free Templates</a>
                  </li>
                  <li>
                    <a href="#">WordPress Themes</a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3">
              <div className="widget">
                <h3>Services</h3>
                <ul className="list-unstyled float-left links">
                  <li>
                    <a href="#">Untree.co</a>
                  </li>
                  <li>
                    <a href="#">jQuery</a>
                  </li>
                  <li>
                    <a href="#">Bootstrap</a>
                  </li>
                  <li>
                    <a href="#">Freebies</a>
                  </li>
                </ul>
              </div>
            </div> */}
            <div className="col-lg-6">
              <div className="widget">
                <h3>Contact</h3>
                <address>Malteserplz, Amberg 92224</address>
                <ul className="list-unstyled links mb-4">
                  {/* <li>
                    <a href="tel://11234567890">+1(123)-456-7890</a>
                  </li> */}
                  <li>
                    <a href="tel://017683365919">+49 17683365919</a>
                    {/* <a href="tel://91577337766">+91 9157733766</a> */}
                  </li>
                  <li>
                    <a href="mailto:ritaliya7@gmail.com">ritaliya7@gmail.com</a>
                  </li>
                </ul>
              </div>
            </div>
            {/* <div className="col-lg-6">
              <div className="widget">
                <h3>Connect</h3>
                <ul
                  className="list-unstyled social "
                  style={{
                    display: "flex",
                  }}
                >
                  <li>
                    <a href="#">
                      <span className="icon-instagram" />
                    </a>
                  </li>
                  <li style={{ marginLeft: "35px" }}>
                    <a href="#">
                      <span className="icon-twitter" />
                    </a>
                  </li>
                </ul>
                <ul
                  className="list-unstyled social "
                  style={{
                    display: "flex",
                  }}
                >
                  <li>
                    <a href="#">
                      <span className="icon-linkedin" />
                    </a>
                  </li>
                  <li style={{ marginLeft: "35px" }}>
                    <a href="#">
                      <span className="icon-pinterest" />
                    </a>
                  </li>
                </ul>

                <ul
                  className="list-unstyled social "
                  style={{
                    display: "flex",
                  }}
                >
                  <li>
                    <a href="#">
                      <span className="icon-dribbble" />
                    </a>
                  </li>
                  <li style={{ marginLeft: "35px" }}>
                    <a href="#">
                      <span className="icon-facebook" />
                    </a>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div id="overlayer" />
      <div className="loader">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>

      {modalImage && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <img src={modalImage} alt="Modal Image" />
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
